import { Organization } from '../../../models/Organization.model'

export const mapMyOrganizations = (organizations?: Organization[]) => {
  if (!organizations) return []

  return organizations.map((o) => ({
    id: o.organizationCode,
    code: o.organizationCode,
    image: o.icon,
    name: o.name,
  }))
}
